import { makeStyles } from '@material-ui/styles';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import FormCard from './FormCard';
import NewFormButton from './newFormButton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getFormEntries } from '../../../redux/DynamicForms/DynamicFormsAction';
import { CircularProgress } from '@material-ui/core';
import WithPatientFileHeader from '../../PatientFileHeader/WithPatientFileHeader';
import MessagesContext from '../../../contexts/messagesContext';
import { createLoadingSelector } from '../../../redux/Loading/LoadingSelector';
import { GET_FORM_ENTRIES } from '../../../redux/DynamicForms/DynamicFormsType';
import { getClinicId } from '../../../utils/storage';

const styles = makeStyles((theme) => ({
    column: {
        display: 'flex',
        flexDirection: 'column',
        // height: 'calc(100vh - 135px)',
        padding: '24px',
        overflow: 'auto',
        [theme.breakpoints.up(1025)]: {
            padding: '5px 24px',
            height: 'calc(100vh - 70px)'
        }
    },
    container: {
        // height: 'calc(100vh - 250px)',
        // overflow: 'auto',
        // height:"100%",
        height: '100%',
        textAlign: 'center'
    },
    loadingContainer: {
        width: '100%',
        height: 'calc(100vh - 350px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));
const FormEntries = () => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const params = useParams();
    const { state } = useLocation();
    const patientId = params?.id;
    const path = `/${params?.clinicId}/patient/${patientId}/forms/form`;
    const loadingSelector = createLoadingSelector(GET_FORM_ENTRIES.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const { entries, more } = useSelector((state) => state.dynamicForms.formEntries);
    const length = entries?.length;
    const dispatch = useDispatch();
    const history = useHistory();
    const [page, setPage] = useState(0);
    const [loadingMore, setLoadingMore] = useState(true);

    const fetchMoreData = () => {
        if (more === 'All') {
            setLoadingMore(false);
            return;
        }

        setTimeout(() => {
            setPage(page + 10);
            setLoadingMore(true);
        }, 300);
    };

    useEffect(() => {
        const param = {
            subject_key: 'patient',
            subject_id: patientId,
            clinic: getClinicId(),
            offset: page,
            limit: 10
        };
        if (page) {
            dispatch(getFormEntries(param));
        }
    }, [page]);

    return (
        <>
            <div className={classes.column} id="scrollableDiv">
                {/* {isMobile ? (
                    <NewForm />
                ) : ( */}
                <NewFormButton handleClick={() => history.push(`${path}/newForm`)} />
                {/* )} */}
                <div className={classes.container}>
                    <InfiniteScroll
                        dataLength={!!length && length}
                        next={fetchMoreData}
                        hasMore={loadingMore}
                        scrollThreshold={0.8}
                        scrollableTarget="scrollableDiv"
                        loader={more !== 'All' && !more && length >= 10 && <span>loading...</span>}
                    >
                        {isLoading ? (
                            <div className={classes.loadingContainer}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <>
                                {state?.isNew && (
                                    <FormCard items={state} isNew={true} path={`${path}/newForm`} />
                                )}
                                {entries &&
                                    entries?.map((item) => (
                                        <FormCard
                                            key={item.id}
                                            items={item}
                                            path={`${path}/${item.id}`}
                                        />
                                    ))}
                            </>
                        )}
                        {!isLoading && !state?.isNew && !entries?.length && (
                            <div className={classes.loadingContainer}>
                                <span>{messages.noFormSubmitted}.</span>
                            </div>
                        )}
                    </InfiniteScroll>
                </div>
            </div>
        </>
    );
};

export default WithPatientFileHeader(FormEntries, ['sidebar', 'visit'], true, false, true);
